/**
 * `tottori-hidden-gem 内のJS
 */
import Swiper from '../../../node_modules/swiper/js/swiper.min';

export default function v1TottoriHiddenGem() {
  // トップ：メインビジュアル
  const slider = '.v1-tottoriHiddenGemkeyVisual .swiper-container';
  const mySwiper = new Swiper(slider, {// eslint-disable-line
    speed: 1000,
    loop: true,
    disableOnInteraction: false,
    effect: 'fade',
    pagination: {
      el: '.v1-tottoriHiddenGemkeyVisual__pagination',
      type: 'fraction',
    },
    autoplay: {
      delay: 5000,
    },
  });

  // トップ：メインビジュアル自動再生一時停止
  const tottoriHiddenGemKeyVisual = () => {
    const keyVisualBtn = document.querySelector('.v1-tottoriHiddenGemkeyVisual__btn');
    if (!keyVisualBtn) {
      return;
    }
    keyVisualBtn.addEventListener('click', () => {
      if (keyVisualBtn.classList.contains('--pause')) {
        keyVisualBtn.classList.remove('--pause');
        keyVisualBtn.classList.add('--play');
        mySwiper.autoplay.stop();
      } else {
        keyVisualBtn.classList.remove('--play');
        keyVisualBtn.classList.add('--pause');
        mySwiper.autoplay.start();
      }
      return false;
    });
  };
  tottoriHiddenGemKeyVisual();

  // トップ：横スクロール一時停止
  const tottoriHiddenGemflowloop = () => {
    const flowloopBtn = document.querySelector('.v1-tottoriHiddenGemFlowloop__btn');
    const flowloopList = document.querySelectorAll('.v1-tottoriHiddenGemFlowloop__list');
    if (!flowloopBtn) {
      return;
    }
    flowloopBtn.addEventListener('click', () => {
      if (flowloopBtn.classList.contains('--pause')) {
        flowloopList.forEach(e => {
          e.classList.add('--pause');
          e.classList.remove('--play');
        });
        flowloopBtn.classList.remove('--pause');
        flowloopBtn.classList.add('--play');
      } else {
        flowloopList.forEach(e => {
          e.classList.add('--play');
          e.classList.remove('--pause');
        });
        flowloopBtn.classList.remove('--play');
        flowloopBtn.classList.add('--pause');
      }
      return false;
    });
  };
  tottoriHiddenGemflowloop();

  // 下層：タブ
  const addTabRole = () => {
    const tablist = document.querySelectorAll('.v1-tottoriHiddenGemAreaSpot__tablist');
    const tab = document.querySelectorAll('.spot_tab-label');
    const tabpanel = document.querySelectorAll('.spot_tab-content');
    Array.from(tablist).forEach(item => {
      item.setAttribute('role', 'tablist');
    });
    Array.from(tab).forEach(item => {
      item.setAttribute('role', 'tab');
    });
    Array.from(tabpanel).forEach(item => {
      item.setAttribute('role', 'tabpanel');
    });
  };
  addTabRole();
  const addTabAriaAttribute = () => {
    const tab = document.querySelectorAll('.spot_tab-label');
    Array.from(tab).forEach((item, index) => {
      const i = index + 1;
      item.setAttribute('aria-controls', `spot_tab-content${i}`);
    });
  };
  addTabAriaAttribute();
  const selectedTabInitial = () => {
    const tab = document.querySelectorAll('.spot_tab-label');
    Array.from(tab).forEach((item, index) => {
      if (index === 0) {
        item.setAttribute('aria-selected', 'true');
      } else {
        item.setAttribute('aria-selected', 'false');
      }
    });
  };
  selectedTabInitial();
  const selectedTabAllFalse = () => {
    const tab = document.querySelectorAll('.spot_tab-label');
    Array.from(tab).forEach(item => {
      item.setAttribute('aria-selected', 'false');
    });
  };
  const selectedTabToggle = () => {
    const tab = document.querySelectorAll('.spot_tab-label');
    Array.from(tab).forEach(item => {
      item.addEventListener('click', () => {
        selectedTabAllFalse();
        item.setAttribute('aria-selected', 'true');
      });
    });
  };
  selectedTabToggle();

  const updateAriaSelected = e => {
    const currentRadio = e.target.id;
    const currentRadioId = currentRadio.match(/[1-4]$/)
      ? currentRadio.match(/[1-4]$/)[0]
      : undefined;
    selectedTabAllFalse();

    // 対応するラベルを取得
    const currentLabel = document.querySelector(`#spot_tab-label${currentRadioId}`);
    const currentLabelId = currentLabel.id.match(/[1-4]$/)
      ? currentLabel.id.match(/[1-4]$/)[0]
      : undefined;

    // ラジオボタンが選択されているかどうかに応じて、aria-selected属性を設定
    if (currentRadioId === currentLabelId) {
      currentLabel.setAttribute('aria-selected', 'true');
    }
  };

  document.addEventListener('keyup', function(event) {
    // キーイベントが矢印キーの場合にのみ処理を行う
    if (
      ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Up', 'Right', 'Down', 'Left'].includes(
        event.key,
      )
    ) {
      updateAriaSelected(event);
    }
  });

  // 下層：エリア絞り込み
  const tottoriHiddenGemAreaSelect = () => {
    const areaSelect = document.querySelectorAll('.js-tottoriHiddenGem-area');
    if (!areaSelect) {
      return;
    }
    areaSelect.forEach(e => {
      const switchNav = e.getElementsByClassName('js-tottoriHiddenGem-area-switch');
      switchNav.forEach(nav => {
        const switchBtn = nav.getElementsByClassName('js-area-btn');
        switchBtn.forEach(btn => {
          if (!switchBtn) {
            return;
          }
          // エリアクリック
          btn.addEventListener('click', element => {
            const obj = element.target;
            const areaHash = obj.dataset.href.replace('#', '');
            const targetItem = obj
              .closest('.js-tottoriHiddenGem-area')
              .getElementsByClassName('js-tottorihiddengem-area-switch-target');
            const areaBtn = obj
              .closest('.js-tottoriHiddenGem-area')
              .getElementsByClassName('js-area-btn');

            // マップactive
            areaBtn.forEach(target => {
              target.classList.remove('active');
              obj.classList.add('active');
            });

            // 該当エリアを表示
            targetItem.forEach(target => {
              const targetData = target.dataset.tag;
              target.classList.add('--hide');
              if (areaHash === targetData) {
                target.classList.remove('--hide');
              } else if (areaHash === 'all') {
                areaBtn.forEach(btnAll => {
                  btnAll.classList.add('active');
                });
                target.classList.remove('--hide');
              }
            });

            return false;
          });
        });
      });
    });
  };
  tottoriHiddenGemAreaSelect();
}
